import {getConfigItem, configConstants} from '@servicenow/ui-config';
import {memoize} from '@servicenow/ui-internal';
import {getInteractionId} from '@servicenow/ui-metrics';
import {
	DISPATCH_EVENT,
	SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED,
	COMPONENT_PROPERTY_UPDATE_REQUESTED
} from '../constants';
import {COMPONENT_ID, PRESENTATIONAL} from '../symbols';
import {getHostVariables} from '../utils';
import {schedule, types} from '../scheduler';
import {applyRuntimeActionHandlers} from './utils';

const {ENABLE_ACTION_DISPATCHED_HANDLING} = configConstants;
const shouldApplyRuntimeActionHandlers = memoize(
	() => getConfigItem(ENABLE_ACTION_DISPATCHED_HANDLING) === true,
	{profileName: 'shouldApplyRuntimeActionHandlers'}
);

const {DISPATCH, IMMEDIATE} = types;

function addEventGetters(event) {
	Object.defineProperty(event, 'path', {
		get() {
			return event.composedPath();
		}
	});
	// FIXME: is there a better, faster way than this?
	Object.defineProperties(event.detail.meta, {
		event: {
			value: event,
			enumerable: true
		},
		path: {
			get() {
				return event
					.composedPath()
					.map(el => {
						const variables = getHostVariables(el);
						return variables && variables[COMPONENT_ID];
					})
					.filter(componentId => componentId);
			}
		}
	});

	return event;
}

function dispatchLegacyEvent(host, detail) {
	const event = new CustomEvent(DISPATCH_EVENT, {composed: true, bubbles: true, detail});
	host.dispatchEvent(addEventGetters(event));
}

export function customEventDispatcher(host, {type, payload, meta, error}) {
	const hostVariables = getHostVariables(host);
	const presentational = hostVariables[PRESENTATIONAL];

	const shouldBubble = meta.internal && type !== COMPONENT_PROPERTY_UPDATE_REQUESTED ? false : true;
	const event = new CustomEvent(type, {
		composed: shouldBubble,
		bubbles: shouldBubble,
		cancelable: true,
		detail: {
			type,
			payload,
			error,
			meta
		}
	});

	schedule({
		fn() {
			if (process.env.UNSAFE_SEISMIC_EMIT_CUSTOM_EVENT) {
				dispatchLegacyEvent(host, {
					type,
					payload,
					error,
					// spread or Object.defineProperties fails because the meta reference is the same
					meta: {...meta}
				});
			}

			if (!presentational && shouldApplyRuntimeActionHandlers())
				applyRuntimeActionHandlers(host, type);
			return host.dispatchEvent(addEventGetters(event));
		},
		meta: {el: host, interactionId: getInteractionId(meta), span: meta.span},
		type: meta[SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED]
			? IMMEDIATE
			: DISPATCH
	});

	return event;
}
